// extracted by mini-css-extract-plugin
export default {"container":"Scoreboard_container__WnyaP"};